const version: string = require("../../../version.json").version;

export const getVersion = (): string => version;
